import React from 'react';
import PropTypes from 'prop-types';

import FormPassword from 'partial/components/form/FormPassword';

const Password = ({
  onChange,
  password,
  passName,
  passwordConfirm,
  passOnly,
  testPassRegex,
}) => (
  <div className="space-y-6">
    <div>
      <FormPassword
        name={passName}
        value={password}
        onSetFieldValue={onChange}
        label="Password"
        required
      />
      {!testPassRegex && password?.length ? (
        <p className="mt-1 text-red-500">
          Password must be at least 10 characters including at least one
          uppercase letter, one lowercase letter, one numeric and one special
          character.
        </p>
      ) : null}
    </div>
    {!passOnly && (
      <div>
        <FormPassword
          name="new_password_confirmation"
          value={passwordConfirm}
          onSetFieldValue={onChange}
          label="Confirm Password"
          required
        />

        {passwordConfirm !== password && passwordConfirm?.length ? (
          <p className="mt-1 text-red-500">Both password must match.</p>
        ) : null}

        {passwordConfirm === password && testPassRegex ? (
          <p className="mt-1 text-green-500">Password matched.</p>
        ) : null}
      </div>
    )}
  </div>
);

Password.defaultProps = {
  passOnly: true,
  passwordConfirm: '',
  passName: 'new_password',
};

Password.propTypes = {
  passOnly: PropTypes.bool,
  passName: PropTypes.string,
  password: PropTypes.string.isRequired,
  passwordConfirm: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testPassRegex: PropTypes.bool.isRequired,
};

export default Password;
